/**
 * Tablet-only drawer host that renders the same filters sidebar as desktop.
 * Closes after Apply or Clear-all-apply so the user returns to the list results.
 */
import { Drawer } from "../../../../../components/drawer/drawer";
import RmaListFiltersStore from "../../../rma-list-page/stores/rma-list-filters-store";
import RmaListFiltersSidebar from "../rma-list-filters-sidebar/rma-list-filters-sidebar";
import "./rma-list-filters-tablet-drawer.scss";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled: boolean;
    onClose: () => void;
}

const RmaListFiltersTabletDrawer: React.FC<IProps> = ({ rmaListFiltersStore, disabled, onClose }) => {
    return (
        <Drawer closeButton={{ onClick: onClose }}>
            <div className="rma-list-filters-tablet-drawer">
                <RmaListFiltersSidebar
                    rmaListFiltersStore={rmaListFiltersStore}
                    disabled={disabled}
                    onFiltersApplied={onClose}
                />
            </div>
        </Drawer>
    );
};

export default RmaListFiltersTabletDrawer;
